import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice du facteur GCF - Plus grand commun diviseur";
const DESCRIPTION =
  "Calculatrice du facteur GCF - Plus grand commun diviseur pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "du facteur gcf plus grand commun diviseur, calculatrice du facteur gcf plus grand commun diviseur, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL =
  "https://do-calculate.com/calculator/fr/gcf-calculator/";
function GCFCalculator() {
  const [num1, setNum1] = useState("");
  const [num2, setNum2] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const gcd = (a, b) => {
    return b === 0 ? a : gcd(b, a % b);
  };
  const handleCalculate = () => {
    try {
      if (!num1 || !num2) {
        setError("Veuillez entrer deux nombres");
        setResult(null);
        return;
      }
      const number1 = parseInt(num1);
      const number2 = parseInt(num2);
      if (number1 === 0 || number2 === 0) {
        setError("Les nombres ne peuvent pas être 0");
        setResult(null);
        return;
      }
      const gcfResult = gcd(Math.abs(number1), Math.abs(number2));
      setResult(gcfResult);
      setError("");
    } catch (err) {
      setError("Erreur lors du calcul");
      setResult(null);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice GCF vous aide à trouver rapidement le plus grand commun diviseur
                  (GCF) de deux nombres ou plus. C'est utile pour simplifier les fractions et résoudre
                  les problèmes mathématiques.
                </p>
                <p>
                  <strong>Le GCF (Plus Grand Commun Diviseur)</strong> est le plus grand nombre qui
                  divise deux nombres ou plus sans laisser de reste.
                </p>
                <ul>
                  <li>Calcul rapide du PGCD</li>
                  <li>Utile pour la simplification de fractions</li>
                  <li>Support pour les nombres positifs</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Premier nombre
                      </label>
                      <input
                        type="number"
                        value={num1}
                        onChange={(e) => setNum1(e.target.value)}
                        placeholder="Entrez le premier nombre"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Deuxième nombre
                      </label>
                      <input
                        type="number"
                        value={num2}
                        onChange={(e) => setNum2(e.target.value)}
                        placeholder="Entrez le deuxième nombre"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer GCF                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p>
                        GCF de {num1} et {num2} = <strong>{result}</strong>
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Qu'est-ce que le PGCD ?</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Le PGCD (Plus Grand Commun Diviseur) est le plus grand nombre entier
                        qui divise exactement deux nombres sans laisser de reste.
                        Par exemple, le PGCD de 8 et 12 est 4, car 4 est le plus grand nombre
                        qui divise à la fois 8 et 12.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Comment calculer le PGCD</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Pour calculer le PGCD, décomposez chaque nombre en facteurs premiers,
                        puis prenez la plus petite puissance de chaque facteur commun.
                        Exemple : PGCD(12, 18) — 12 = 2² × 3, 18 = 2 × 3² — PGCD = 2 × 3 = 6.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Importance du PGCD</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Le PGCD est essentiel pour simplifier les fractions, résoudre des
                        problèmes numériques et appliquer la théorie des nombres en
                        mathématiques et en ingénierie.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default GCFCalculator;
